import React from 'react';
import { CheckCircle2, Leaf } from 'lucide-react';
import { specialtiesData } from '../data/mock';

const SpecialtiesSection = () => {
  return (
    <section className="specialties-section py-20 md:py-32 relative overflow-hidden">
      <div className="specialties-bg absolute inset-0 z-0"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 mb-6 specialty-badge">
            <Leaf className="h-5 w-5" />
            <span className="text-sm font-semibold uppercase tracking-wider">What Makes Us Special</span>
          </div>
          
          <h2 className="text-4xl md:text-6xl font-bold mb-8">
            {specialtiesData.title}
          </h2>
          
          <p className="text-xl md:text-2xl mb-12 opacity-90">
            Committed to quality, sustainability, and inclusivity in every bite
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {specialtiesData.items.map((item, index) => (
              <div key={index} className="specialty-item group">
                <CheckCircle2 className="h-6 w-6 mb-3 specialty-icon" />
                <span className="text-lg font-semibold">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialtiesSection;
